import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeDelta';
const args = {};

export class ModeDelta extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
